import { render } from "./ticket.vue?vue&type=template&id=e5b76c94"
import script from "./ticket.vue?vue&type=script&lang=ts"
export * from "./ticket.vue?vue&type=script&lang=ts"
script.render = render

export default script